module.exports = __webpack_public_path__ + "static/media/PDF.285fe75f.png";